import { rfqJobQuotesPaginationStyles } from "@insite/content-library/Widgets/RfqJobQuotes/RfqJobQuotesPagination";
import { getMgbwPaginationOverrides } from "@tSurya/Common/Utilities/mgbwPaginationOverrides";

rfqJobQuotesPaginationStyles.pagination = getMgbwPaginationOverrides();
